import React from 'react';
import { Segment, Header, Button, Table, Checkbox } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

export default class StudentsWithGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedData: [],
        };

        this.onSelectRow = this.onSelectRow.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.addToGroup = this.addToGroup.bind(this);
    }

    onSelectRow(id) {
        const row = this.props.data.find(el => el.id === id);
        const pos = this.state.selectedData.findIndex(el => el.id === row.id);
        if (pos === -1) {
            // add to selectedData
            this.setState({ selectedData: [...this.state.selectedData, row] });
        } else {
            // remove from selectedData
            const newSelectedData = this.state.selectedData.filter(el => el.id !== row.id);
            this.setState({ selectedData: newSelectedData });
        }
    }

    selectAll() {
        const { selectedData } = this.state;
        // deselect all if data.length === selectedData.length
        if (selectedData.length === this.props.data.length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: this.props.data });
        }
    }

    addToGroup() {
        if (!this.state.selectedData.length) {
            toast('Niste odabrali nijednog studenta!');
            return;
        }
        let list = [];
        this.state.selectedData.map(el => {
            list.push(el.id);
        });

        let staffGroup = list.map(el => ({
            courseImplementationStaff: { id: el },
            courseImplementationGroup: { id: this.props.courseImplementationGroupId }
        }));

        axios.post('course/groups/add-staff', [...staffGroup])
            .then(ress => {
                toast('Uspješno ste dodali nastavno osoblje u grupu.');
                this.props.getStaff();
            })
            .catch(e => {
                toast('Došlo je do greške! Dodavanje nastavnog osoblja nije uspjelo.');
            });
    }


    render() {
        const { selectedData } = this.state;

        return (
            <Segment.Group raised clearing style={{ backgroundColor: 'white' }}>
                <Segment clearing>
                    <Header as="h3">
                        Nastavno osoblje na predmetu
                    </Header>
                </Segment>
                <Segment clearing>
                    {this.props.data.length ?
                        <div><Table celled selectable compact>
                            <Table.Header>
                                <Table.Row >
                                    {this.props.edit && <Table.HeaderCell width={1}>
                                        <Checkbox
                                            type="checkbox"
                                            name="checkAllButton"
                                            value={selectedData.length === this.props.data.length}
                                            onChange={this.selectAll}
                                            checked={selectedData.length === this.props.data.length}
                                        />
                                    </Table.HeaderCell>}
                                    <Table.HeaderCell>
                                                Ime
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                                Prezime
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                              Uloga na predmetu
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {this.props.data.map((el, index) =>
                                (<Table.Row negative={this.props.groupStaff.find(e=> e.courseImplementationStaff.id === el.id)} onClick={() => this.onSelectRow(el.id)}>
                                        {this.props.edit && <Table.Cell verticalAlign="middle">
                                        <Checkbox
                                            name={el.id}
                                            type="checkbox"
                                            checked={selectedData.findIndex(e => e.id === el.id) > -1}
                                        />

                                    </Table.Cell>}
                                    <Table.Cell verticalAlign="middle">
                                        {el.employee.person.firstName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.employee.person.lastName}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.courseRoleType.name}
                                    </Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                            {this.props.edit && <Button color="blue" floated="right" onClick={this.addToGroup}>
                                      Dodaj u grupu
                            </Button>}
                        </div>
                        : <div>Svo nastavno osoblje je već dodano u grupu.</div>
                    }
                </Segment>
                <ToastContainer hideProgressBar />
            </Segment.Group>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/StaffWithoutGroup.js